import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { Body1, colors, H4, spacing } from 'ui/theme';
import { EmptyState } from 'ui/illustrations';

import { ContentTable, PageHeader } from './components';
import { DISPLAY_CONTENT } from './constants';

const { headerText, bodyText } = DISPLAY_CONTENT.missingPermission;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${spacing.x6};
  text-align: center;
`;

const EmptyStateSecondaryText = styled(Body1)`
  color: ${colors.textSecondary};
`;

export const GlobalSmsSettings = () => {
  const canViewGlobalSms = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageProjectSettings,
  );
  return !canViewGlobalSms ? (
    <EmptyStateContainer data-test="global-sms-missing-permission-state">
      <EmptyState />
      <H4>{headerText}</H4>
      <EmptyStateSecondaryText>{bodyText}</EmptyStateSecondaryText>
    </EmptyStateContainer>
  ) : (
    <>
      <PageHeader />
      <ContentTable />
    </>
  );
};
